import { SuccessCallback } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { awaitDataServiceFetcher } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/DataServiceFetchers';
import { normalizeEmptyResponseToSuccessResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/infrastructure';
import { IFavouriteTransfersRepository } from '../entities/IFavouriteTransfersRepository';
import { FavouriteTransfer, NewFavouriteAppTransactionRequestDTO } from '../entities';
import { NewFavouriteTransferBody } from '../entities/NewFavouriteTransferResponseDTO';
import { NewFavouriteAppTransactionBody } from '../entities/NewFavouriteAppTransactionResponseDTO';
import { DeleteFavouriteTransferResponseBody } from '../entities/DeleteFavouriteTransferResponseDTO';
import { EditFavouriteTransferResponseBody } from '../entities/EditFavouriteTransferResponseDTO';
import { FavouriteTransfersList } from '../entities/FavouriteTransfersListResponseDTO';
import { FavouriteTransferDTODataType } from '../types';
import { favouriteTransferListDTOToFavouriteListAdapter } from './favouriteTransferListDTOtoFavouriteTransferListAdapter';
import { favouriteTransferDTOToFavouriteTransferAdapter } from './favouriteTransferDTOtoFavouriteTransferAdapter';

class FavouriteTransfersRepositoryImpl implements IFavouriteTransfersRepository {
  constructor() {
    this.GetFavouriteTransfers = this.GetFavouriteTransfers.bind(this);
    this.CreateNewFavouriteTransfer = this.CreateNewFavouriteTransfer.bind(this);
    this.CreateNewFavouriteAppTransaction = this.CreateNewFavouriteAppTransaction.bind(this);
    this.DeleteFavouriteTransfer = this.DeleteFavouriteTransfer.bind(this);
    this.EditFavouriteTransfer = this.EditFavouriteTransfer.bind(this);
    this.GetFavouriteTransfer = this.GetFavouriteTransfer.bind(this);
  }

  GetFavouriteTransfers(
    customerId: number,
    pageSize: number,
    pageOffset: number,
    name?: string,
    debitAccountNumber?: string,
    creditAccountNumber?: string,
    amountFrom?: number,
    amountTo?: number,
    currency?: string,
  ): Promise<FavouriteTransfersList> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'GET',
        url: `/secure-web/api/private/transfers/favorites/${customerId}`,
        dataAdapter: favouriteTransferListDTOToFavouriteListAdapter,
        params: {
          perPage: pageSize,
          page: pageOffset,
          name,
          debitAccountNumber,
          creditAccountNumber,
          amountFrom,
          amountTo,
          currency,
        },
      },
    });
  }

  CreateNewFavouriteTransfer(
    appTransactionUniqueId: number,
    name: string,
    customerId: string,
    shared: boolean,
    successCallback?: SuccessCallback,
    errorCallback?: ErrorCallback,
  ): Promise<NewFavouriteTransferBody> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'POST',
        url: '/secure-web/api/private/transfers/favorites/app-transaction',
        data: {
          name,
          customerId: Number(customerId),
          shared,
          appTransactionUniqueId: Number(appTransactionUniqueId),
        },
        nextCallback: successCallback,
        onErrorCallback: errorCallback,
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
      },
    });
  }

  CreateNewFavouriteAppTransaction(
    data: NewFavouriteAppTransactionRequestDTO,
  ): Promise<NewFavouriteAppTransactionBody> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'POST',
        url: '/secure-web/api/private/transfers/favorites/app-transaction',
        data,
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
      },
    });
  }

  DeleteFavouriteTransfer(
    customerId: number,
    id: number,
    successCallback?: SuccessCallback,
  ): Promise<DeleteFavouriteTransferResponseBody> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'DELETE',
        url: `/secure-web/api/private/transfers/favorites/${customerId}/${id}`,
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
        nextCallback: successCallback,
      },
    });
  }

  EditFavouriteTransfer(
    customerId: number,
    id: number,
    name: string,
    shared: boolean,
    data: FavouriteTransferDTODataType,
    successCallback?: SuccessCallback,
  ): Promise<EditFavouriteTransferResponseBody> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'PUT',
        url: `/secure-web/api/private/transfers/favorites/${customerId}/${id}`,
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
        data: {
          name,
          shared,
          data,
        },
        nextCallback: successCallback,
      },
    });
  }

  GetFavouriteTransfer(customerId: number, id: number): Promise<FavouriteTransfer> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'GET',
        url: `/secure-web/api/private/transfers/favorites/${customerId}/${id}`,
        dataAdapter: favouriteTransferDTOToFavouriteTransferAdapter,
      },
    });
  }
}

export { FavouriteTransfersRepositoryImpl };
